import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { WordComponent } from './word.component';
import { HomonymComponent } from './homonym/homonym.component';
import { Homonym2Component } from "./homonym2/homonym2.component";
import {SajaseungeoComponent} from "./sajaseungeo/sajaseungeo.component";



const routes: Routes = [
  {
    path: 'word',
    component: WordComponent,
  },
  // {
  //   path: 'homonym',
  //   component: HomonymComponent,
  // },
  {
    path: 'homonym',
    component: Homonym2Component,
  },
  {
    path: 'sajaseungeo',
    component: SajaseungeoComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class WordRoutingModule {}
